import { render, staticRenderFns } from "./ScrollContainer.vue?vue&type=template&id=edbacfea&scoped=true"
import script from "./ScrollContainer.vue?vue&type=script&lang=js"
export * from "./ScrollContainer.vue?vue&type=script&lang=js"
import style0 from "./ScrollContainer.vue?vue&type=style&index=0&id=edbacfea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edbacfea",
  null
  
)

export default component.exports